<mat-card>
  <mat-card-content>
    <mat-list>
      <pr-patient-relationship-list [patient]="patient" />
    </mat-list>
  </mat-card-content>
</mat-card>
